interface PennantProps {
  /** Rendered width/height in px (the mark is square). */
  size?: number;
  className?: string;
}

/** The Markcat brand mark — flat pennant + M. Single source for every surface.
 *  Theme-resolved: clay fill + white M on Paper themes, cyan fill + near-black M
 *  on Circuit (--pennant-fill / --pennant-glyph in themes.css). Decorative:
 *  always aria-hidden — pair it with a visible wordmark or label. */
export function Pennant({ size = 24, className }: PennantProps) {
  return (
    <svg viewBox="0 0 128 128" width={size} height={size} aria-hidden="true" focusable="false" className={className}>
      <path d="M16 8h96a8 8 0 0 1 8 8v96l-52-20-52 20V16a8 8 0 0 1 8-8Z" fill="var(--pennant-fill)" />
      <text x="64" y="78" textAnchor="middle" fontFamily="system-ui,sans-serif" fontSize="64" fontWeight="700" fill="var(--pennant-glyph)">M</text>
    </svg>
  );
}
